import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MobilePlayerCell } from '.';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { MobileTableAccordionContent } from './MobileTableAccordionContent';
import { MobileTableRoundHeaderRow } from './MobileTableRoundHeaderRow';
import { MobileTableVotesRow } from './MobileTableVotesRow';
import { MobileTablePredictedRow } from './MobileTablePredictedRow';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import BettingOddsCell from '../BettingOddsCell';

const cssClass = 'player-awards-tracker-leaderboard-mobile-table';

export const MobileTableBody = ({
    rows,
    onPlayerFavouriteClick,
    favourites,
    prepareRow,
    skipCells,
    seasonPid,
    isBrownlowV2,
    showPredictedData,
    primaryTooltipComponent,
    showLeader,
    shouldHidePredicted,
    activeColumn,
    status
}) => {
    const [activeRows, setActiveRows] = useState([0]);

    const nav = useSelector(navSelector);
    const rounds = nav?.rounds;

    const handleClick = (index) => {
        if (activeRows.indexOf(index) !== -1) {
            setActiveRows(activeRows.filter((item) => item !== index));
        } else {
            setActiveRows((prev) => [...prev, index]);
        }
    };

    const getTrProps = (row) => {
        let classes = '';

        if (
            (row.original.player.winner || row.original.player.leader) &&
            showLeader
        ) {
            classes = `${cssClass}--is-leader`;
        }

        if (!row.original.player.eligible) {
            classes = classes + ` ${cssClass}--is-ineligible`;
        }

        if (classes.length) {
            return {
                className: classes
            };
        }
    };

    return (
        <>
            {/* Fake Tbody */}
            <div>
                {rows.map((row, index) => {
                    prepareRow(row);

                    const isActive = activeRows.indexOf(index) !== -1;

                    const cells = row.cells.filter((cell) => {
                        if (!skipCells) {
                            return true;
                        }
                        return !skipCells.includes(cell.column.id);
                    });

                    // sort cells into top and bottom rows
                    const topRow = [],
                        bottomRow = [];

                    cells.forEach((cell) => {
                        if (
                            cell.column.id === 'player' ||
                            cell.column.id === 'totalVotes' ||
                            cell.column.id === 'bettingOdds'
                        ) {
                            topRow.push(cell);
                        } else {
                            bottomRow.push(cell);
                        }
                    });

                    const accordionProps = {
                        cssClass,
                        isActive,
                        isBrownlowV2,
                        rowData: bottomRow,
                        rounds,
                        showPredictedData,
                        primaryTooltipComponent
                    };

                    return (
                        <div
                            key={index}
                            {...row.getRowProps()}
                            {...getTrProps(row)}
                        >
                            {/* Top row */}
                            <div
                                className={`${cssClass}__body-row ${cssClass}__body-row-top`}
                            >
                                {topRow.map((cell, i) => {
                                    const cellProps = cell.getCellProps();

                                    switch (cell.column.id) {
                                        case 'player':
                                            return (
                                                <MobilePlayerCell
                                                    {...cellProps}
                                                    player={cell.value}
                                                    onPlayerFavouriteClick={
                                                        onPlayerFavouriteClick
                                                    }
                                                    favourites={favourites}
                                                    cell={cell}
                                                    seasonPid={seasonPid}
                                                    shouldHidePredicted={
                                                        shouldHidePredicted
                                                    }
                                                    isBrownlowV2={isBrownlowV2}
                                                    count={i + 1}
                                                    status={status}
                                                />
                                            );
                                        case 'totalVotes':
                                            return (
                                                <div
                                                    {...cellProps}
                                                    className="stats-table__total-votes-cell"
                                                    onClick={() =>
                                                        handleClick(index)
                                                    }
                                                >
                                                    {cell.value}
                                                    <SvgIcon
                                                        className={`icon ${
                                                            isActive
                                                                ? 'icon--flipped'
                                                                : ''
                                                        }`}
                                                        icon="chevron-down"
                                                    />
                                                </div>
                                            );
                                        case 'bettingOdds':
                                            return (
                                                <BettingOddsCell
                                                    row={row}
                                                    cell={cell}
                                                    cellProps={cellProps}
                                                />
                                            );
                                        default:
                                            return <></>;
                                    }
                                })}
                            </div>

                            <MobileTableAccordionContent
                                cssClass={cssClass}
                                isActive={accordionProps.isActive}
                            >
                                {!isBrownlowV2 && (
                                    <MobileTableRoundHeaderRow
                                        {...accordionProps}
                                        activeColumn={activeColumn}
                                    />
                                )}
                                <MobileTableVotesRow {...accordionProps} />
                                {showPredictedData && (
                                    <MobileTablePredictedRow
                                        {...accordionProps}
                                    />
                                )}
                            </MobileTableAccordionContent>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

MobileTableBody.propTypes = {
    rows: PropTypes.array.isRequired,
    onPlayerFavouriteClick: PropTypes.func,
    favourites: PropTypes.array,
    prepareRow: PropTypes.func.isRequired,
    skipCells: PropTypes.array,
    seasonPid: PropTypes.string,
    isBrownlowV2: PropTypes.bool,
    showPredictedData: PropTypes.bool,
    primaryTooltipComponent: PropTypes.func,
    showLeader: PropTypes.bool,
    shouldHidePredicted: PropTypes.bool,
    title: PropTypes.string,
    activeColumn: PropTypes.number,
    status: PropTypes.string
};
